import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { HelixBookFormService } from '../../services/helix-book-form.service';
import { HelixBookRepositoryService } from '../../services/helix-book-repository.service';

@Component({
  selector: 'app-helixbook-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent implements OnInit, OnDestroy {
  constructor(
    public repository: HelixBookRepositoryService,
    public formService: HelixBookFormService
  ) {}

  ngUnsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.formService.form.controls.search.valueChanges
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((value) => {
        this.repository.setActiveKey('');
        this.repository.setSearchPhrase(value ?? '');
      });
    this.formService.reset();
  }

  clearSearch(): void {
    this.formService.reset();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
